"use strict";

angular.module("diceApp").component("modalCloseButton", {
  bindings: {
    onClick: "&"
  },
  templateUrl: "es6/base/forms/buttons/modal.close.button.html",
  controllerAs: "modalCloseButtonController"
});
